import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalendarService, ICalendar } from '@shared/services/calendar.service';

@Component({
	selector: 'app-delete-calendar',
	templateUrl: './delete-calendar.component.html',
	styleUrls: ['./delete-calendar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteCalendarComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public calendar: ICalendar,
		public dialogRef: MatDialogRef<DeleteCalendarComponent>,
		private calendarService: CalendarService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';

		this.calendarService.deleteCalendarById(this.calendar.id).subscribe({
			next: () => {
				this.deleted.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;

				this.deleted.error(errorResponse);
				this.dialogRef.close();
			},
		});
	}
}
